<div class="px-3 py-3">
<div
  fxLayout="column"
  fxLayoutAlign="space-between"
  fxLayoutGap="20px"
  fxFlexFill
> 
  <div class="row justify-content-center">
    <div class="col-xxl-6 col-xl-7 col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center">
      <mat-card class="bulk-update-form-container">
        <h3 class="content-label-each" translate>pages.newRetailer.bulkRetailerPricelistUpdate</h3>
        <form [formGroup]="bulkPricelistupdateForm" (ngSubmit)="onSubmit()"> 
          <div class="row g-0 mt-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.pricelist <span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select placeholder="{{ 'pages.placeholders.Selectpricelist' | translate }}"
                  formControlName="pricelist"
                  >
                    <mat-option
                    *ngFor="let pricelist of pricelists"
                [value]="pricelist"
              >
                {{ pricelist }}
              </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="f.pricelist.touched && f.pricelist.invalid">
                  <div *ngIf="f.pricelist.errors.required">
                    <mat-hint class="text-danger ms-2"> {{'pages.placeholders.Pricelistisrequired' | translate }}</mat-hint>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row g-0 mt-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.productGroup <span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select placeholder="Select ProductGroup"
                  formControlName="productGroup"
                  >
                    <mat-option
                    *ngFor="let productGroup of productGroups"
                [value]="productGroup"
              >
                {{ productGroup }}
              </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="f.productGroup.touched && f.productGroup.invalid">
                  <div *ngIf="f.productGroup.errors.required">
                    <mat-hint class="text-danger ms-2"> {{'pages.placeholders.Productgroupisrequired' | translate }}</mat-hint>
                  </div>
                </div>
              </div>
            
            
            </div>
          </div>
          <div class="row g-0 mt-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.carrier
              </h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select placeholder="Select Carrier"
                  formControlName="carrier"
                  >
                    <mat-option
                    *ngFor="let carrier of carriers"
                [value]="carrier.carrierName"
              >
                {{ carrier.carrierName }}
              </mat-option>
                  </mat-select>
                </mat-form-field>
                
              </div>

            </div>
          </div>
          <div class="row g-0 mt-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <h4 class="form-item-label">
                {{'pages.placeholders.RetailerCommission' | translate }}
              </h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-25" appearance="outline">
                  <mat-select
                    formControlName="priceListValueType"                   
                  >
                    <mat-option value="$">$</mat-option>
                    <mat-option value="%">%</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="w-75" appearance="outline">
                  <input
                    matInput
                    type="text"
                    placeholder="Enter Retailer Commission"
                    formControlName="retailerCommission"
                  />
                </mat-form-field>
                
              </div>
              
            </div>
          </div>
          <div class="form-footer mt-5">
            <ul class="list-inline text-center">
              <li class="list-inline-item">
                <button
                  mat-raised-button
                  color="primary"
                  type="submit"
                  class="rounded-0"
                  [disabled]="checkSubmitDisplayed()"
                >
                  <span translate class="translate">pages.newRetailer.update</span>
                </button>
              </li>
              <li class="list-inline-item">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  class="rounded-0"
                  (click)="onCancel()"
                >
                  <span translate class="translate">pages.newRetailer.cancel</span>
                </button>
              </li>
              <li class="list-inline-item"></li>
            </ul>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</div>
</div>